import { useEffect, useState } from "react";

export default function  Footer() {
    const [year, setYear] = useState('')
    useEffect(() => {
        const getYear = new Date().getFullYear()
        setYear(getYear)
    }, [year])
    
    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">
                        {year} © InnerMember.
                    </div>
                    <div className="col-sm-6">
                        <div className="text-sm-end d-none d-sm-block">
                            Design & Develop by DIGITAL WEB
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}